export const constructProduct = (product) => {
    const [itemType, id] = product.itemId.split('-');
    const constructedProduct = {
        itemType,
        id,
        product,
        shoppingProducts: [],
        products: [],
        homeDeliveryProducts: [],
        icf: {
            vpc: '',
            images: [
                {
                    typeCode: '',
                    url: ''
                }
            ]
        }
    };
    return constructedProduct;
};
//# sourceMappingURL=constructProduct.js.map